import { Flex } from "src/elements";
import styled from "styled-components";

const outlineThickness = "2px";

export const SelectionOutliner = styled(Flex)`
  position: absolute;
  width: calc(100% + 2 * ${outlineThickness});
  height: calc(100% + 2 * ${outlineThickness});
  top: -${outlineThickness};
  left: -${outlineThickness};
  border-radius: 3px;
  pointer-events: none;
  z-index: 1;

  background-image:
    linear-gradient(90deg, black 50%, white 50%), linear-gradient(90deg, black 50%, white 50%),
    linear-gradient(0deg, black 50%, white 50%), linear-gradient(0deg, black 50%, white 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size:
    15px ${outlineThickness},
    15px ${outlineThickness},
    ${outlineThickness} 15px,
    ${outlineThickness} 15px;
  background-position:
    left top,
    right bottom,
    left bottom,
    right top;
  animation: border-dance 1s infinite linear;

  @keyframes border-dance {
    0% {
      background-position:
        left top,
        right bottom,
        left bottom,
        right top;
    }

    100% {
      background-position:
        left 15px top,
        right 15px bottom,
        left bottom 15px,
        right top 15px;
    }
  }
`;
